import type { EmbeddedRegistrationFormSectionData } from "./EmbeddedRegistrationFormSection";

export type PasswordStatus = {
  hasCapitalLetter: boolean;
  hasSpecialCharacters: boolean;
  isLengthCorrect: boolean;
  hasLowerCaseLettersOrDigits: boolean;
};

export type PasswordCriteriaProps = {
  passwordStatus: PasswordStatus;
};

export type EmailStatus = {
  alreadyExists: boolean;
  needsVerification: boolean;
  lastBrokenEmail?: string;
};

export enum VerificationError {
  USER_NOT_VERIFIED = "USER_NOT_VERIFIED",
  USER_ALREADY_EXISTS = "USER_ALREADY_EXISTS"
}

export enum FieldNames {
  firstName = "firstName",
  lastName = "lastName",
  email = "email",
  password = "password",
  termsOfUse = "termsOfUse",
  privacyPolicy = "privacyPolicy"
}

export type UserValidationError = {
  validated: boolean;
  message: "ok";
  errors?: {
    code: VerificationError;
    value: FieldNames.email;
    __typename: "ValidateSignupUserErrorPayload";
  }[];
};

export type EmailFieldProps = EmailStatus & {
  setValue: (email: string | undefined) => void;
  value: string | undefined;
};

export type PasswordFieldProps = {
  setIsPasswordCorrect: (isPasswordCorrect: boolean) => void;
};

export type EmbeddedRegistrationFormProps = Pick<
  EmbeddedRegistrationFormSectionData,
  "backgroundColor" | "redirectURL"
>;
